module.exports = __webpack_public_path__ + "static/media/cliffshurricanecreek.3957ba6a.jpg";